import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  UpsertFrontAppIntegrationResponseDataSchema,
  UpsertFrontAppIntegrationSchema,
} from "schema"
import { z } from "zod"
import { frontAppIntegrationQueryKey } from "../../lib/frontapp/frontappIntegrationQuery"

type Response = DataResponse<z.infer<typeof UpsertFrontAppIntegrationResponseDataSchema>>

export function useUpsertFrontAppIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof UpsertFrontAppIntegrationSchema>) => {
      const response = await axios.post<Response>(`/integrations/frontapp`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: frontAppIntegrationQueryKey })
    },
  })
}
